module.exports = __webpack_public_path__ + "static/media/logo-on-dark.b4f59467.svg";